// extracted by mini-css-extract-plugin
module.exports = {"main-component":"featureRiver_main-component__1jqrG"};